// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    /* Style additionnel pour le tableau Bootstrap des installations */
    .custom-bs-table thead th {
        background-color: #f8fafc;
        color: #475569;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        border-bottom: 2px solid #e2e8f0;
        white-space: nowrap;
    }

    .custom-bs-table tbody td {
        font-size: 0.9rem;
        color: #334155;
        vertical-align: middle;
    }

    .custom-bs-table tbody tr:hover {
        background-color: #f8fafc;
    }

    /* Pagination */
    .pagination .page-link {
        color: #475569;
        border-color: #e2e8f0;
    }

    .pagination .page-item.active .page-link {
        background-color: #818cf8;
        border-color: #818cf8;
        color: #fff;
    }

    .pagination .page-item.disabled .page-link {
        color: #cbd5e1;
    }

    /* Mobile : réduire un peu le texte et le padding */
    @media (max-width: 576px) {

        .custom-bs-table thead th,
        .custom-bs-table tbody td {
            font-size: 0.8rem;
            padding: 8px 10px;
        }
    }`, "",{"version":3,"sources":["webpack://./src/assets/css/historiqueAlert.css"],"names":[],"mappings":"IAAI,kEAAkE;IAClE;QACI,yBAAyB;QACzB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,yBAAyB;QACzB,sBAAsB;QACtB,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,eAAe;IACf;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA,mDAAmD;IACnD;;QAEI;;YAEI,iBAAiB;YACjB,iBAAiB;QACrB;IACJ","sourcesContent":["    /* Style additionnel pour le tableau Bootstrap des installations */\n    .custom-bs-table thead th {\n        background-color: #f8fafc;\n        color: #475569;\n        font-size: 0.8rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.03em;\n        border-bottom: 2px solid #e2e8f0;\n        white-space: nowrap;\n    }\n\n    .custom-bs-table tbody td {\n        font-size: 0.9rem;\n        color: #334155;\n        vertical-align: middle;\n    }\n\n    .custom-bs-table tbody tr:hover {\n        background-color: #f8fafc;\n    }\n\n    /* Pagination */\n    .pagination .page-link {\n        color: #475569;\n        border-color: #e2e8f0;\n    }\n\n    .pagination .page-item.active .page-link {\n        background-color: #818cf8;\n        border-color: #818cf8;\n        color: #fff;\n    }\n\n    .pagination .page-item.disabled .page-link {\n        color: #cbd5e1;\n    }\n\n    /* Mobile : réduire un peu le texte et le padding */\n    @media (max-width: 576px) {\n\n        .custom-bs-table thead th,\n        .custom-bs-table tbody td {\n            font-size: 0.8rem;\n            padding: 8px 10px;\n        }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
